module.exports = __webpack_public_path__ + "img/alt9.73298e92.jpg";